import { render, staticRenderFns } from "./installClone.vue?vue&type=template&id=9341f5dc&scoped=true&"
import script from "./installClone.vue?vue&type=script&lang=js&"
export * from "./installClone.vue?vue&type=script&lang=js&"
import style0 from "./installClone.vue?vue&type=style&index=0&id=9341f5dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9341f5dc",
  null
  
)

export default component.exports